import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import downArrow from '../../../assets/images/down_arrow.svg';
import downArrowBlue from '../../../assets/images/down_arrow_blue.svg';
import ServiceModal from './ServiceModal';
import DeleteModal from './DeleteModal';
import utils from '../../../lib/utils';

import { Prompt } from 'react-router-dom';

import './index.scss';
import editIcon from '../../../assets/images/edit.svg';
import deleteIcon from '../../../assets/images/delete.svg';

const sortDataBy = (data, byKey, order) => {
  let sortedData = data.sort((a, b) => {
    let x = a[byKey].toLowerCase();
    let y = b[byKey].toLowerCase();
    if (x > y) return 1 * order;
    if (x < y) return -1 * order;
    return 0;
  });
  return sortedData;
};

export default class StaffMapping extends React.Component {
  constructor() {
    super();
    this.state = {
      addStaffModalOpen: false,
      deleteStaffModalOpen: false,
      selectedStaff: {},
      currentpage: 1,
      totalPage: 1,
      countPerPage: 10,
      staffCount: 1,
      showPopup: false,
      sortField: 'name',
      sortOrder: 1,
      selectedResources: [],
      selectedTemplates: [],
      selectedService: 'Add',
      staffMap:{}
    };
  }

  componentDidMount() {
    const { business } = this.props;
    const staffMapping = business?.details?.data?.dental_preference?.scheduling?.staff_schedule_mapping || [];
    const staffLength = staffMapping.length;

    this.setState({
      staffCount: staffLength,
      totalPage: Math.ceil(staffLength / this.state.countPerPage),
      staffMap: staffMapping
    });
  }

  componentWillReceiveProps(nextProps) {
    const { auth, business, schedules } = nextProps;
    const { studio_id } = auth;
    const { countPerPage, currentpage } = this.state;
    const bzid = this.props.business.id || studio_id;
    
    const staffMapping = business?.details?.data?.dental_preference?.scheduling?.staff_schedule_mapping || {};
    const currentStaffCount = Object.keys(staffMapping).length;
    if (
      !utils.isEmptyObject(nextProps?.business?.details) &&
      nextProps?.business?.details !== this.props?.business?.details
    ) {
      this.setState({
        totalPage: Math.ceil(currentStaffCount / countPerPage),
        staffMap: staffMapping
      });
    }
  }
  
  getStaff = (id) => {
    const staffs = this.props?.business?.details?.staffs;
    const staff = staffs.find(staff => staff.id === id);
    return staff
  }
  getResources = (id) => {
    const resources = this.props?.business?.details?.resources;
    const resource = resources.find(resource => resource.id === id);
    return resource
  }

  getStaffMapping = () => {
    const { currentpage, countPerPage, sortField, sortOrder, staffMap } = this.state;

    let staffList = Object.keys(staffMap).map((key) => ({ id: key, ...staffMap[key] }));
    
    // staffList = staffList.length > 0 ? sortDataBy(staffList, sortField, sortOrder) : [];

    const start = (currentpage - 1) * countPerPage;
    const end = Math.min(currentpage * countPerPage, staffList.length);

    return staffList.slice(start, end);
  };

  openAddStaffModal = () => {
    this.setState({
      addStaffModalOpen: true,
      selectedStaff: {},
      selectedService: 'Add'
    });
  };

  openEditStaffModal = (staff) => {
    const selectedResources = staff.resource_ids.map((id) => {
      const resource = this.getResources(id);
      return resource ? { label: resource.name, value: resource.id } : null;
    }).filter(resource => resource !== null);

    const selectedTemplates = staff.schedule_template_names.map((template_name) => {
      return template_name ? { label: template_name, value: template_name} : null;
    }).filter(template_name => template_name !== null);

    const selectedStaff = { value: staff.id, label: this.getStaff(staff.id).name};

    this.setState({
      addStaffModalOpen: true,
      selectedStaff,
      selectedResources: selectedResources,
      selectedTemplates: selectedTemplates,
      selectedService: 'Edit'
    });
  };
  

  openDeleteStaffModal = (staff) => {
    const selectedStaff = { value: staff.id, label: this.getStaff(staff.id).name };
    this.setState({
      deleteStaffModalOpen: true,
      selectedStaff,
    });
  };

  closeStaffModal = () => {
    this.setState({
      addStaffModalOpen: false,
      selectedStaff: {},
    });
  };

  closeDeleteStaffModal = () => {
    this.setState({
      deleteStaffModalOpen: false,
      selectedStaff: {}
    })
  }

  handleSort = (field, order) => {
    this.setState({
      sortField: field,
      sortOrder: order,
    });
  };

  handlePageChange = (page) => {
    this.setState({
      currentpage: page,
    });
  };

  updatStaffMap = (staffData, type) => {
    const { staffMap, selectedStaff } = this.state;
    if (type === 'Edit') {
      const { [selectedStaff.value]: eitedStaff, ...rest } = staffMap;
      this.setState((prevState) => ({
        staffMap: { ...rest, ...staffData }, // Merging new keys
        addStaffModalOpen: false
      }));
    } else if(type === 'Delete') {
      const { [selectedStaff.value]: deletedStaff, ...rest } = staffMap;
      this.setState((prevState) => ({
        staffMap: { ...rest }, // Merging new keys
        deleteStaffModalOpen: false
      }));
    } else {
      this.setState((prevState) => ({
        staffMap: { ...staffMap, ...staffData }, // Merging new keys
        addStaffModalOpen: false
      }));
    }
  }
  
  
  render() {
    const { business, schedules, staffmapping } = this.props;
    const { addStaffModalOpen, deleteStaffModalOpen, selectedStaff, currentpage, countPerPage, totalPage, showPopup, sortField, sortOrder, selectedResources, selectedTemplates, selectedService, staffMap } = this.state;

    const errorMessage = 'Something went wrong';

    return (
      <div className="schedule">
        <Prompt
          when={false}
          message={'There are unsaved changes, are you sure you want to leave without saving?'}
        />

        <div className="schedule_title">
          <div className="schedule_title_content">
            <div className="title">Staff Mapping</div>
            <button className="add-service" onClick={this.openAddStaffModal}>
              + Add Staff Mapping
            </button>
          </div>
          
          <div className="schedule_title_table">
            <div className="schedule_title_table_header">
              <div className="row name">
                STAFF
                <img
                  className={classnames('arrow', { 'rotate-arrow': sortOrder === -1 && sortField === 'name' })}
                  src={sortField !== 'name' ? downArrow : downArrowBlue}
                  onClick={() => this.handleSort('name', sortOrder * -1)}
                />
              </div>
              <div className="row duration">RESOURCES
              <img
                  className={classnames('arrow', { 'rotate-arrow': sortOrder === -1 && sortField === 'resources' })}
                  src={sortField !== 'resources' ? downArrow : downArrowBlue}
                  onClick={() => this.handleSort('resources', sortOrder * -1)}
                />
              </div>
              <div className="row duration">TEMPLATES
              <img
                  className={classnames('arrow', { 'rotate-arrow': sortOrder === -1 && sortField === 'templates' })}
                  src={sortField !== 'templates' ? downArrow : downArrowBlue}
                  onClick={() => this.handleSort('templates', sortOrder * -1)}
                />
              </div>
              <div className="actions"></div>
            </div>
            {Object.keys(staffMap).length < 1 ? (
              <div className="schedule_title_table_body">
                <div className="no-service-types">
                  {' '}
                  No staff mapping. Add one to get started.
                </div>
              </div>
            ) : (
              <div className="schedule_title_table_body">
                {this.getStaffMapping().map((staff) => (
                  <div className="servie-type-container">
                    <div className="servie-type-container_name">
                      {this.getStaff(staff.id).name}
                    </div>
                    <div className='servie-type-container_resources'>
                      {staff.resource_ids.length > 0 ? staff.resource_ids.map((id) => (
                        <p>{this.getResources(id).name}</p>
                      )) : 'N/A'}{' '}
                    </div>
                    <div className="servie-type-container_templates">
                      {staff.schedule_template_names.length > 0 ? staff.schedule_template_names.join(', ') : 'N/A'}
                    </div>
                    <div className="servie-type-container_actions">
                      <img src={editIcon} onClick={() => this.openEditStaffModal(staff)} alt="edit" />
                      <img src={deleteIcon} onClick={() => this.openDeleteStaffModal(staff)} alt="delete" />
                    </div>
                  </div>
                ))}
              </div>)}
            {this.state.staffCount > 0 && (
              <div className="schedule_title_table_pagination">
                <div className="count">
                  Showing {(currentpage - 1) * countPerPage + 1}-
                  {currentpage * countPerPage > this.state.staffCount ? this.state.staffCount : currentpage * countPerPage}{' '}
                  of {this.state.staffCount} entries
                </div>
                <div className="paging">
                  {currentpage !== 1 && (
                    <span className="page-number" onClick={() => this.handlePageChange(currentpage - 1)}>
                      PREV
                    </span>
                  )}
                  {Array.from({ length: totalPage }, (_, i) => i + 1).map((page) => (
                    <span
                      className={classnames('page-number', { active: page === currentpage })}
                      onClick={() => this.handlePageChange(page)}
                      key={page}
                    >
                      {page}
                    </span>
                  ))}
                  {totalPage !== currentpage && (
                    <span className="page-number" onClick={() => this.handlePageChange(currentpage + 1)}>
                      NEXT
                    </span>
                  )}
                </div>
              </div>
            )}
              
                <div className="schedule_title_table_save">
                  <button
                    className="btn btn--primary btn--lg"
                onClick={() => this.props.updateStaffMapping(staffMap)}
                disabled={staffmapping?.updating}
                  >
                {staffmapping?.updating ? 'SAVING..' : 'SAVE'}
                  </button>
                </div>
          </div>
        </div>

        {showPopup && (
          <div className="copy-webhook">
            <span className="tick-mark">
              <i className="material-icons">check</i>
            </span>
            Update was successful. Please save the changes for it to reflect.
          </div>
        )}

        {addStaffModalOpen && (
          <ServiceModal
            modelopen={addStaffModalOpen}
            closeStaffModal={this.closeStaffModal}
            business={business}
            selectedStaff={selectedStaff}
            selectedResources={selectedResources}
            selectedTemplates={selectedTemplates}
            selectedService={selectedService}
            updatStaffMap={this.updatStaffMap}
          />
        )}
        {deleteStaffModalOpen && (
          <DeleteModal
            selectedStaff={selectedStaff}
            modelopen={deleteStaffModalOpen}
            closeStaffModal={this.closeDeleteStaffModal}
            updatStaffMap={this.updatStaffMap}
            business={business}
          />
        )}
      </div>
    );
  }
}
